export const violationsSkjenk = [
  {
    name: 'intoxicated',
    label: 'Åpenbart påvirket person i lokalet',
    requiresAdditionalReport: true,
  },
  {
    name: 'under18',
    label: 'Salg, utlevering eller skjenking til person som er under 18 år',
    requiresAdditionalReport: true,
  },
  {
    name: 'group3Under20',
    label: 'Skjenking av alkoholholdig drikk gruppe 3 til person på 18 eller 19 år',
    requiresAdditionalReport: true,
  },
  {
    name: 'ageRequirementEmployee',
    label: 'Brudd på alderskravet til den som selger, utleverer eller skjenker alkoholholdig drikk',
    requiresAdditionalReport: true,
  },
  {
    name: 'alcoholServingDrugged',
    label: 'Skjenking til person som er eller må antas å bli åpenbart påvirket av rusmidler',
    requiresAdditionalReport: true,
  },
  {
    name: 'alcoholRegulationsIndoors',
    label: 'Brudd på skjenketidsbestemmelsene inne',
    requiresAdditionalReport: true,
  },
  {
    name: 'alcoholRegulationsOutdoors',
    label: 'Brudd på skjenketidsbestemmelsene ute',
    requiresAdditionalReport: true,
  },
  {
    name: 'consumptionHoursIndoors',
    label: 'Brudd på konsumtid inne',
    requiresAdditionalReport: true,
  },
  {
    name: 'consumptionHoursOutdoors',
    label: 'Brudd på konsumtid ute',
    requiresAdditionalReport: true,
  },
  {
    name: 'dutyToAssist',
    label: 'Brudd på bistandsplikt',
    requiresAdditionalReport: true,
  },
  {
    name: 'preventInspection',
    label: 'Hindring av kommunal kontroll',
    requiresAdditionalReport: true,
  },
  {
    name: 'properOperation',
    label: 'Brudd på krav om forsvarlig drift',
    requiresAdditionalReport: true,
  },
  {
    name: 'nonAlcoholicAlternative',
    label: 'Brudd på krav om alkoholfrie alternativer',
    requiresAdditionalReport: false,
  },
  {
    name: 'consumptionOwnAlcohol',
    label: 'Konsum av medbrakt alkoholholdig drikk',
    requiresAdditionalReport: false,
  },
  {
    name: 'alcoholBroughtOutside',
    label: 'Gjester tar med alkoholholdig drikk ut av lokalet',
    requiresAdditionalReport: false,
  },
  {
    name: 'termsViolated',
    label: 'Brudd på vilkår i bevillingsvedtak',
    requiresAdditionalReport: false,
  },
  {
    name: 'advertisement',
    label: 'Brudd på reklamebestemmelsene',
    requiresAdditionalReport: false,
  },
  {
    name: 'amountGroup3',
    label: 'Brudd på reglene om skjenkemengde av gruppe 3',
    requiresAdditionalReport: false,
  },
  {
    name: 'internalControl',
    label: 'Mangler ved internkontroll',
    requiresAdditionalReport: false,
  },
  {
    name: 'managerDeputy',
    label: 'Brudd på krav om styrer og stedfortreder',
    requiresAdditionalReport: false,
  },
  {
    name: 'drugs',
    label: 'Gjentatt narkotikaomsetning',
    requiresAdditionalReport: false,
  },
  {
    name: 'discrimination',
    label: 'Gjentatt diskriminering',
    requiresAdditionalReport: false,
  },
  {
    name: 'otherViolations',
    label: 'Andre overtredelser',
    requiresAdditionalReport: false,
  },
];

export const violationsSalg = [
  {
    name: 'ageRequirementEmployee',
    label: 'Brudd på alderskrav til den som selger alkoholholdig drikk',
    requiresAdditionalReport: true,
  },
  {
    name: 'saleDrugged',
    label: 'Salg til person som er åpenbart påvirket av rusmidler',
    requiresAdditionalReport: true,
  },
  {
    name: 'saleHours',
    label: 'Brudd på salgstidsbestemmelsene',
    requiresAdditionalReport: true,
  },
  {
    name: 'preventInspection',
    label: 'Hindring av kommunal kontroll',
    requiresAdditionalReport: true,
  },
  {
    name: 'properOperation',
    label: 'Brudd på krav om forsvarlig drift',
    requiresAdditionalReport: true,
  },
  {
    name: 'salesUnderage',
    label: 'Salg til mindreårige',
    requiresAdditionalReport: true,
  },
  {
    name: 'termsViolated',
    label: 'Brudd på vilkår i bevillingsvedtaket',
    requiresAdditionalReport: false,
  },
  {
    name: 'advertisement',
    label: 'Brudd på reklamebestemmelsene',
    requiresAdditionalReport: false,
  },
  {
    name: 'internalControl',
    label: 'Mangler ved internkontroll',
    requiresAdditionalReport: false,
  },
  {
    name: 'alcoholPlacement',
    label: 'Brudd på kravet om plassering av alkoholholdig drikk',
    requiresAdditionalReport: false,
  },
  {
    name: 'managerDeputy',
    label: 'Brudd på krav om styrer og stedfortreder',
    requiresAdditionalReport: false,
  },
  {
    name: 'otherViolations',
    label: 'Andre overtredelser',
    requiresAdditionalReport: false,
  },
];

export const violationsTobacco = [
  {
    name: 'tobaccoNotRegistered',
    label: 'Mangelfull registrering i Tobakkssalgsregisteret',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoInternalControl',
    label: 'Mangelfull internkontroll',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoSalesBan',
    label: 'Salg i strid med salgsforbud',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoSalesUnderage',
    label: 'Salg til mindreårig',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoSelfService',
    label: 'Selvbetjening',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoFree',
    label: 'Gratis utdeling',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoDiscount',
    label: 'Rabatt',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoAdvertisement',
    label: 'Reklame',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoSponsorship',
    label: 'Sponsing',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoOnDisplay',
    label: 'Synlig oppstilling',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoDesignAndWarnings',
    label: 'Standardisert utforming og helseadvarsler',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoHideWarnings',
    label: 'Produkter som skjuler helseadvarsler',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoLeastAmountPerPack',
    label: 'Minste antall tobakksvarer per enkeltforpakning',
    requiresAdditionalReport: true,
  },
  {
    name: 'tobaccoConsumerTesting',
    label: 'Forbrukertesting',
    requiresAdditionalReport: true,
  },
];
